import { UserModel } from '../models';

export const checkPermission = (user=new UserModel(), permissions=[], key) => {
  if(user.isSuperAdmin() || user.isExSuperAdmin()) return true;
  if(!permissions?.length || !key) return false;
  const p = permissions.find(k => k.value === key && k.type === 'C2U' && k.read === 1);
  return p? true: false;
};
